function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    position: "relative",
    width: "100%",
    padding: props => {
      return theme.spacing(props.padding);
    },
    display: "flex",
    "& > * + *": {
      flexGrow: 1,
      marginLeft: props => {
        return theme.spacing(props.spacing);
      }
    },
    "& > *:first-child": {
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: props => {
        return props.minWidth;
      },
      minHeight: props => {
        return props.minHeight;
      }
    }
  }
}));

const LayoutThumbnail = (_ref) => {
  let _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? 164 : _ref$minWidth,
      _ref$minHeight = _ref.minHeight,
      minHeight = _ref$minHeight === void 0 ? 164 : _ref$minHeight,
      padding = _ref.padding,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 2 : _ref$spacing,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["minWidth", "minHeight", "padding", "spacing", "children"]);

  const classes = useStyles({
    minWidth,
    padding,
    spacing
  });
  return React.createElement("div", {
    className: classes.root
  }, children);
};

export default LayoutThumbnail;